import React from 'react'
import PropTypes from 'prop-types'
import Measure from 'react-measure'
import ReactQRCode from 'qrcode.react'
import EthereumQRCode from 'ethereum-qr-code/build/ethereum-qr-code'
import { css } from 'aphrodite'
import createStyles from './styles'

export class QRCode extends React.Component {
  state = {
    size: undefined,
  }

  handleResize = rect =>
    this.setState({
      size: rect.bounds.width,
    })

  render() {
    const styles = getStyles(this.props, this.context)
    const ethereumQRCodeGenerator = new EthereumQRCode()
    const address = ethereumQRCodeGenerator.toAddressString(this.props)

    return (
      <Measure bounds onResize={this.handleResize}>
        {({ measureRef }) => (
          <div ref={measureRef} className={css(styles.root)}>
            <ReactQRCode value={address} size={this.state.size} />
          </div>
        )}
      </Measure>
    )
  }
}

QRCode.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles(props => ({
  root: {
    width: '50%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}))



// WEBPACK FOOTER //
// ./src/components/QRCode.js